import { KeyboardService } from './@core/data/keyboard.service';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF, CommonModule, registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {NgxElectronModule} from 'ngx-electron';
import { PagesModule } from './pages/pages.module';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { ToasterModule } from 'angular2-toaster';
import ar from '@angular/common/locales/ar';
import fr from '@angular/common/locales/fr';
import { arabic } from './../assets/i18n/ar';
import { english } from './../assets/i18n/en';
import { french } from './../assets/i18n/fr';
import { Observable } from 'rxjs';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';
import { TourNgxBootstrapModule } from 'ngx-tour-ngx-bootstrap';
import { DeviceDetectorModule } from 'ngx-device-detector';

// the second parameter 'fr' is optional
registerLocaleData(fr, 'fr');
registerLocaleData(ar, 'ar');

export class CustomTranslateLoader implements TranslateLoader {
  public getTranslation(lang: string): Observable<any> {
      return Observable.create(observer => {
          if (lang === 'ar') {
              observer.next(arabic);
          } else if (lang === 'fr') {
              observer.next(french);
          } else {
            observer.next(english);
          }
          observer.complete();
      });
  }
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    TranslateModule.forRoot({loader: {
      provide: TranslateLoader,
      useClass: CustomTranslateLoader
  },
}),
  NgxElectronModule,
  SweetAlert2Module.forRoot(),
  NgxSpinnerModule,
  TourNgxBootstrapModule.forRoot(),
  DeviceDetectorModule.forRoot(),
  ],
  exports: [
TranslateModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    KeyboardService,
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LOCALE_ID, useValue: 'en-US' }
  ],
})
export class AppModule {
}
